<template>
  <a-layout>
    <div class="side-bar">
      <a-layout-sider
        v-model:collapsed="collapsed"
        :trigger="null"
        collapsible
        :collapsed-width="64"
        width="280px"
        class="z-[100]"
      >
        <div
          :class="[
            `py-2 px-5 flex items-center ${
              collapsed ? 'justify-center' : 'justify-between'
            } h-[48px]`
          ]"
        >
          <router-link v-if="!collapsed" :to="{ path: '/' }">
            <img src="/logo_sider_bar_white.jpg" alt="" style="width: 75%; height: auto" />
          </router-link>
          <menu-unfold-outlined
            v-if="collapsed"
            class="trigger"
            style="color: white; font-size: 24px"
            @click="handleCollapseMenu"
          />
          <menu-fold-outlined
            v-else
            class="trigger"
            style="color: white; font-size: 24px"
            @click="handleCollapseMenu"
          />
        </div>
        <SiderMenu :menus="menus" :collapsed="collapsed" @toggleCollapse="toggleCollapse" />
      </a-layout-sider>
    </div>

    <a-layout
      class="layout-main-content"
      :class="`layout-${nameRouter?.name?.replace(/[./]/g, '-')}`"
    >
      <global-header />
      <a-layout-content
        class="main-content"
        :style="{
          padding: '8px',
          backgroundColor: '#f5f5f5'
        }"
      >
        <router-view />
      </a-layout-content>
      <global-footer />
    </a-layout>
  </a-layout>
  <modal-warning-change-password
    :visible="showModalChangePassword"
    @close-modal="closeModalWarningChangePassword"
  />
</template>

<script lang="ts" setup>
import { MenuUnfoldOutlined, MenuFoldOutlined } from '@ant-design/icons-vue'
import { onMounted, ref } from 'vue'
import SiderMenu from '@/components/menu/SideMenu.vue'
import { useRoute, useRouter } from 'vue-router'
import GlobalHeader from '@/components/header/index.vue'
import GlobalFooter from '@/components/footer/index.vue'
import { getItemFromLocalStorage, setItemToLocalStorage } from '@/utils'
import { KEY_LOCAL } from '@/contants'
import { useAuthStore } from '@/stores/authStore.ts'
import ModalWarningChangePassword from '@/components/account/ModalChangePassword.vue'

const nameRouter = useRoute()
const menus = ref([])
const collapsed = ref<boolean>(false)
const {
  auth: { showModalChangePassword }
} = useAuthStore()

onMounted(() => {
  const originRouter = useRouter()
  const routerMenu = originRouter.getRoutes().find((item) => item.path === '/')
  menus.value = (routerMenu && routerMenu.children) || []

  const collapseValue = getItemFromLocalStorage(`${KEY_LOCAL}collapsedSideMenu`)
  collapsed.value = typeof collapseValue === 'boolean' ? collapseValue : false
})

const toggleCollapse = () => {
  if (!collapsed.value) {
    setItemToLocalStorage(`${KEY_LOCAL}collapsedSideMenu`, true)
    collapsed.value = true
  }
}
const handleCollapseMenu = () => {
  collapsed.value = !collapsed.value
  setItemToLocalStorage(`${KEY_LOCAL}collapsedSideMenu`, collapsed.value)
}

const closeModalWarningChangePassword = () => {
  const authStore = useAuthStore()
  authStore.setShowModalChangePassword(false)
}
</script>

<style scoped lang="scss">
.page-transition-enter {
  opacity: 0;
}

.page-transition-leave-active {
  opacity: 0;
}

.page-transition-enter .page-transition-container,
.page-transition-leave-active .page-transition-container {
  transform: scale(1.5);
}
.main-content {
  overflow-y: scroll;
}

.side-bar {
  .ant-layout-sider {
    position: sticky;
    top: 0;
    left: 0;
    bottom: 0;
  }
}
</style>
